import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withApollo } from 'react-apollo';
import { withRouter, Link } from 'react-router-dom';
import { Layout, Icon, Menu, Dropdown } from 'antd';
import MuiButton from 'material-ui/Button';
import Avatar from '../images/avatar.png';
import Logo from '../images/logo.png';

const { Header } = Layout;

class AppHeader extends Component {
  state = {
    userName: '',
    isAdmin: false,
  };

  componentWillMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.setState({
      userName: user.name,
      isAdmin: user.isAdmin,
    });
  }

  handleMenuClick = (item) => {
    if (item.key === 'logout') {
      // Remove user from localstorage
      localStorage.removeItem('user');
      localStorage.removeItem('userApiToken');
      // Clear the apollo-client store
      this.props.client.resetStore();
      // Redirect to login page
      this.props.history.push('/login');
    }
  };

  menu = (
    <Menu onClick={this.handleMenuClick}>
      <Menu.Item key="logout">
        Logout
      </Menu.Item>
    </Menu>
  );

  render() {
    return (
      <Header className="ec-header">
        <div className="container-fluid">
          <div className="row">
            {/* Company Logo */}
            <div className="col-auto">
              <img className="ec-header-company-logo" src={Logo} alt="Bizminder Logo" />
            </div>
            {/* Menu */}
            <div className="col">
              <Link to="/app"><MuiButton>Dashboard</MuiButton></Link>
              <Link to="/app/leads"><MuiButton>Leads</MuiButton></Link>
              <Link to="/app/customers"><MuiButton>Customers</MuiButton></Link>
              {
                this.state.isAdmin ?
                  <Link to="/app/admin/employees"><MuiButton>Admin</MuiButton></Link>
                  :
                  null
              }
            </div>
            {/* User */}
            <div className="col-auto">
              <div className="row no-gutters">
                <div className="col-auto">
                  <img className="ec-header-avatar" src={Avatar} alt="User avatar" />
                </div>
                <div className="col-auto ec-header-user">
                  <Dropdown overlay={this.menu} trigger={['click']}>
                    <a className="ant-dropdown-link" href="#">
                      {this.state.userName} <Icon type="down" />
                    </a>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
    );
  }
}

AppHeader.propTypes = {
  client: PropTypes.shape({
    resetStore: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  withRouter,
  withApollo,
)(AppHeader);



// WEBPACK FOOTER //
// ./src/components/AppHeader.jsx